import { useQuery } from '@apollo/client'
import { GET_SALES_CHANNELS } from 'features/Services/queries-legacy'
import { GTSalesChannelTypeV2, GTSalesChannelV2, GTSalesChannelsOutput } from 'gql/types.generated'

interface IUseSalesChannelAutocompleteOptions {
  skip?: boolean
}

const getEmptySalesChannelById = (salesChannelId: string): GTSalesChannelV2 => ({
  id: salesChannelId,
  name: '',
  type: GTSalesChannelTypeV2.Online,
  country: {
    id: '',
    name: '',
    code: '',
    currency: {
      id: '',
      code: '',
      symbol: '',
      name: ''
    }
  },
  createdAt: null,
  updatedAt: null
})

export const useSalesChannelsAutocomplete = (
  salesChannelsIds: string[],
  { skip }: IUseSalesChannelAutocompleteOptions = {}
): GTSalesChannelV2[] => {
  const { data } = useQuery<{ salesChannels: GTSalesChannelsOutput }>(GET_SALES_CHANNELS, {
    skip,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      pagination: {
        page: 0,
        size: 10000
      }
    }
  })

  return (
    data?.salesChannels?.items?.filter((salesChannel) => salesChannelsIds.includes(salesChannel.id)) ||
    salesChannelsIds.map((salesChannelId) => getEmptySalesChannelById(salesChannelId))
  )
}

export const useSalesChannelAutocomplete = (
  salesChannelId: string,
  { skip }: IUseSalesChannelAutocompleteOptions = {}
): GTSalesChannelV2 => {
  const { data } = useQuery<{ salesChannels: GTSalesChannelsOutput }>(GET_SALES_CHANNELS, {
    skip,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      pagination: {
        page: 0,
        size: 10000
      }
    }
  })

  return (
    data?.salesChannels?.items?.find((salesChannel) => salesChannel.id === salesChannelId) ||
    getEmptySalesChannelById(salesChannelId)
  )
}
